// extracted by mini-css-extract-plugin
module.exports = {"main":"AppOverlay_main__leJ5r","tutorial_navigation_container":"AppOverlay_tutorial_navigation_container__3t0ps"};